import React, { FC } from 'react';

import { getStreamsCategoryPath, StreamsCategoryParamValues } from 'application/pages/StreamPage';
import { usePlayerContext } from 'application/providers/PlayerProvider';
import AnalyticsService, { EventNameAMP, ParamNameAMP, StreamTypeValues } from 'application/services/AnalyticsService';
import FileUtils from 'application/utils/FileUtils';
import { useLocation } from 'application/providers/RouterProvider';
import { DEMO_TITLE } from './texts';
import { MediaListItem } from '../MediaListItem';
import { MediaListProps } from '../types';

interface MediaListItemDemoProps {
  streamDemo: MediaListProps['streamDemo'];
  isStreamPlaying?: MediaListProps['isStreamPlaying'];
  streamId: MediaListProps['streamId'];
}

export const MediaListItemDemo: FC<MediaListItemDemoProps> = ({ streamId, streamDemo, isStreamPlaying }) => {
  const location = useLocation();
  const { isPaused, progress, play, pause, resume, changeProgress } = usePlayerContext();

  const isMediafilePlaying = Boolean(isStreamPlaying);
  const currentProgress = isMediafilePlaying ? progress : undefined;
  const isDemo = Boolean(streamDemo);

  if (location.pathname.includes(getStreamsCategoryPath(StreamsCategoryParamValues.SAVED))) {
    return null;
  }

  const onClickPlayHandler = () => {
    if (streamDemo) {
      const fileUrl = FileUtils.getMediafileUrl(streamDemo.sourcefiles);

      play({
        fileUuid: streamDemo.id,
        fileName: streamDemo.filename,
        fileUrl,
      });

      AnalyticsService.event(EventNameAMP.PLAY_TRACK_PRESSED, {
        [ParamNameAMP.STREAM_ID]: streamId,
        [ParamNameAMP.STREAM_TYPE]: StreamTypeValues.TEMPLATE,
        [ParamNameAMP.TRACK_ID]: streamDemo?.id,
        [ParamNameAMP.IS_DEMO]: true,
        [ParamNameAMP.IS_PROMO]: false,
      });
    }
  };

  return (
    <MediaListItem
      isDemo={isDemo}
      title={DEMO_TITLE}
      isMediafilePlaying={isMediafilePlaying}
      progress={currentProgress}
      onClickPlay={onClickPlayHandler}
      onClickPause={pause}
      onChangeProgress={changeProgress}
      onClickResume={resume}
      isPaused={isPaused}
    />
  );
};
